import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';

import { Subscription, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

import { ContributionService } from '../../core/services/contribution.service';
import { ToastService } from '../../core/services/toast.service';
import { LocalActions } from '../../state';

@Component({
    selector: 'gs-contribution-pending',
    templateUrl: './contribution-pending.component.html',
    standalone: false
})
export class ContributionPendingComponent implements OnInit, OnDestroy {
  contribution: any;

  private subscriptions: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private contributionService: ContributionService,
    private toastService: ToastService,
    private store: Store,
  ) {
  }

  ngOnInit() {
    const contributionId = this.route.snapshot.paramMap.get('id');

    this.subscriptions.push(
      this.store.select<string>(state => state.local.lastContributionId)
        .subscribe(lastContributionId => {

          if (!contributionId || lastContributionId != contributionId) {
            this.router.navigate(['/error']);
            return;
          }

          this.getContribution(contributionId);
        })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());

    // Remove ContributionId to avoid confirmation page being reaccessed
    this.store.dispatch(new LocalActions.SetLastContribution(null));
  }

  private getContribution(contributionId: string) {
    this.subscriptions.push(
      this.contributionService.getContribution(contributionId)
        .pipe(
          catchError(e => {
            this.toastService.checkErrorForStatus(e);
            return throwError(e);
          }),
          finalize(() => { })
        )
        .subscribe((response: any) => {
          this.contribution = response;
        })
    );

  }

}
